export default "__VITE_ASSET__Bie$6JCP__"